// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"58909d7b","157":"58909d7b","800":"58909d7b"}[chunkId] + ".chunk.css";
};